// @ts-check
import _ from 'lodash';
import React, { Component } from 'react';
import Hotkeys from 'react-hot-keys';
import { FaMapMarkerAlt, FaMapPin } from 'react-icons/fa';
import { connect } from 'react-redux';
import { Button, Col, Row, Spinner } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { liveTrackingUrl } from '../../config';
import {
  formatDate,
  formatList,
  formatLookerFilterDate,
  getLookerWeekRange,
  service,
} from '../../helpers';
import Logger from '../../helpers/Logger';
import { parseQuestions } from '../../helpers/questionParser';
import { showAndHide, showMessage } from '../../redux/reducers/message';

import './Submission.scss';
import {
  ImageInfo,
  ImagesComponent,
  // NewEmbededRow,
  QuestionRow,
  RejectionModal,
  SKURow,
  SkuHeader,
  SoftRejectionModal,
  Table,
} from './SubmissionComponents';
import { brandConfigs } from '../../config/brandConfigs';
import {
  ApprovedTasksDashboardBR25,
  ApprovedTasksDashboardBR30,
  ApprovedTasksDashboardBR35,
  ApprovedTasksDashboardBR40,
  ApprovedTasksDashboardCO,
  ApprovedTasksDashboardMX,
} from '../../components/dashboards/ApprovedTasks';
import { KeywordCrossCheckDashboard } from '../../components/dashboards/KeywordCrossCheck';

function getShowLiveTrackingUrl(data) {
  if (
    !data ||
    !data.submission ||
    !data.submission.additionalData ||
    !data.submission.additionalData.meta ||
    !data.submission.additionalData.meta.type
  ) {
    return false;
  }
  const submissionType = data.submission.additionalData.meta.type;
  switch (submissionType) {
    case 'MERCHANDISING': // 1
    case 'INVENTORY': // 5
    case 'CONVENIENCE_STORE': // 6
    case 'SALES': // 9
    case 'BAIT_REFERRAL': // 10
    case 'ACCOUNT': // 13
    case 'PROFILE': // 14
    case 'CANCELLATION': // 19
    case 'OPEN_MERCHANDISING': // 22
    case '':
    case null:
    case undefined:
      return false;
    default:
      return true;
  }
}

const dropDown = [
  {
    label: '166%',
    value: 'AT_166pc',
  },
  {
    label: '133%',
    value: 'AT_133pc',
  },
  {
    label: '100%',
    value: 'AT_100pc',
  },
];

const CUSTOM_APPROVE_OPTIONS = {
  TWO_FOR_ONE: {
    label: 'Approve 2 for 1',
    getBonus: (value) => value,
    constraint: (value) => value <= 5000,
    errorAlert: 'Error: Task value is over 5000. Cannot approve at 2 for 1',
  },
  AT_100: {
    label: 'Approve at 100',
    getBonus: (value) => 100 - value,
    constraint: (value) => value <= 100,
    errorAlert: 'Error: Task value is over 100. Cannot approve at 100',
  },
  AT_120: {
    label: 'Approve at 120',
    getBonus: (value) => 120 - value,
    constraint: (value) => value <= 120,
    errorAlert: 'Error: Task value is over 120. Cannot approve at 120',
  },
  AT_40: {
    label: 'Approve at 40',
    getBonus: (value) => 40 - value,
    constraint: (value) => value <= 40,
    override_value: 40,
    errorAlert: 'Error: Task value is over 40. Cannot approve at 40',
  },
  AT_50: {
    label: 'Approve at 50',
    getBonus: (value) => 50 - value,
    constraint: (value) => value <= 50,
    override_value: 50,
    errorAlert: 'Error: Task value is over 50. Cannot approve at 50',
  },
  AT_166pc: {
    label: 'Approve at 166%',
    getBonus: (value) => Math.ceil(value * 0.6666),
    constraint: (value) => value >= 0,
    errorAlert: 'Error: Task value is under 0. Cannot approve at 0',
  },
  AT_100pc: {
    label: 'Approve at 100%',
    getBonus: (value) => 0,
    constraint: (value) => value >= 0,
    errorAlert: 'Error: Task value is under 0. Cannot approve at 0',
  },
  AT_133pc: {
    label: 'Approve at 133%',
    getBonus: (value) => Math.ceil(value * 0.3333),
    constraint: (value) => value >= 0,
    errorAlert: 'Error: Task value is under 0. Cannot approve at 0',
  },
};

const customApproveKeys = ['AT_50'];

const EXTRA_APPROVE_BTNS = Object.entries(CUSTOM_APPROVE_OPTIONS).filter(
  ([key]) => customApproveKeys.includes(key),
);

const googleMapsUrl = (coordinates1, coordinates2) =>
  `https://www.google.com/maps/dir/${coordinates1.latitude},${coordinates1.longitude}/${coordinates2.latitude},${coordinates2.longitude}`;

class Submission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      loading: true,
      loadingAction: false,
      currentImage: null,
      mapModal: false,
      rejectFormModal: false,
      softRejectFormModal: false,
      imageInfo: false,
      auth: null,
      parsedQuestions: null,
      rejections: null,
      embed: null,
      filterNumber: /** @type {string|null} */ (null),
      promo: 'AT_100pc',
      brandId: /** @type {number|null} */ (null),
    };

    this.images = [];
    this.toggleMap = this.toggleMap.bind(this);
    this.toggleRejectForm = this.toggleRejectForm.bind(this);
    this.toggleSoftRejectForm = this.toggleSoftRejectForm.bind(this);
    this.id = null;
    this.messageText = '';
    this.skuData = null;
    this.keysData = null;

    this.getPromoSelectedhandleChange =
      this.getPromoSelectedhandleChange.bind(this);
  }

  componentDidMount = () => {
    const {
      location: { search },
    } = this.props;
    this.id = this.props.match.params.id;
    if (search) {
      const reviewingParam = 'reviewingId';
      const param = search.split('?').find((v) => v.includes(reviewingParam));
      this.reviewingId = param ? param.split('=')[1] : null;
    }
    this.setState({ auth: this.props.auth });
    this.load(this.id);
  };

  parseDataKeys = (data) => {
    if (!data) return;
    const keys = [];
    _.forEach(data, (v, k) => {
      keys.push(v.key);
    });
    this.setState({ keys: data });
    return keys;
  };

  /**
   * @param {string|number} brandId
   * @param {{skus:Array<Record<string, any>>}} parsed
   */
  getFilterValue = (brandId, parsed) => {
    const brandConfig = brandId in brandConfigs ? brandConfigs[brandId] : {};
    const nameString = brandConfig.nameString;
    const keyword = brandConfig.keyword;

    let filterValue = [];

    parsed.skus.forEach((sku) => {
      if (nameString && Array.isArray(nameString) && Array.isArray(keyword)) {
        nameString.map((str, index) => {
          if (nameString[index].includes(sku.nameString)) {
            filterValue[index] = sku[keyword[index]];
          }
        });
      } else if (nameString && nameString.includes(sku.nameString)) {
        filterValue = sku[keyword];
      }
    });
    return filterValue;
  };

  getLastSoftReject = (response) => {
    if (response) {
      const comments = [];
      const rejectionCauses = [];

      response.forEach((elem) => {
        const metadata = elem.metaData;
        comments.push(`${metadata.comments}, `);
        const rejection = Object.assign({}, ...metadata.rejectionCauses);
        rejectionCauses.push(rejection);
      });

      return {
        comments,
        rejectionCauses,
      };
    }
    return null;
  };

  load = async () => {
    this.setState({ loading: true });

    try {
      const keysData = await service.get('zombie/quesion-keys/');
      const keys = this.parseDataKeys(keysData);

      const rejections = await service.get('zombie/rejection-causes/');

      this.setState({ rejections });

      const response = await service.get(
        `zombie/submission-metadata/${this.id}/`,
      );

      if (this.reviewingId) {
        const submissionResult = await service.get(
          `zombie/user-submissions/${this.reviewingId}`,
        );

        if (submissionResult) {
          response.submissionResult =
            submissionResult.submissionResult.charAt(0).toUpperCase() +
            submissionResult.submissionResult.slice(1);
        }
      }

      response.submission.additionalData =
        response.submission.additionalData != null
          ? JSON.parse(response.submission.additionalData)
          : null;

      const { taskId, additionalData } = response.submission;
      const allowSoftReject = additionalData && additionalData.allowSoftReject;

      if (!this.reviewingId && allowSoftReject) {
        const responseSoftReview = await service.get(
          `zombie/last-submissions-soft/?task_id=${taskId}`,
        );
        response.lastSoftReject = this.getLastSoftReject(responseSoftReview);
      }

      const currImg = response.images.length > 0 ? response.images[0] : null;
      const parsed = parseQuestions(response, keys);

      // FIXME: this is a temporal solution for Wallmart shoppers tasks, so
      // if the task is from Wallmart then we have to get the order number to validate it
      // against our db

      const brandId = Number(_.get(response, 'brand.id', -1));
      const brandConfig = brandId in brandConfigs ? brandConfigs[brandId] : {};

      const filterNumber =
        !_.isEmpty(brandConfig) && parsed.skus && parsed.skus.length > 0
          ? this.getFilterValue(brandId, parsed)
          : 0;

      this.setState({
        loading: false,
        data: response,
        parsedQuestions: parsed,
        currentImage: currImg,
        brandConfig,
        filterNumber,
        brandId,
      });
    } catch (e) {
      Logger.error(e);
      this.setState({ error: true, loading: false });
      this.handleError(e);
    }
  };

  handleSubmit = async (values) => {
    try {
      const result = await service.put(
        `zombie/submission-metadata/${this.id}/`,
        values,
      );
      return result;
    } catch (e) {
      return this.handleError(e);
    }
  };

  handleSRSubmit = async (values) => {
    try {
      const result = await service.put(
        `zombie/submission-metadata-soft/${this.id}/`,
        values,
      );
      return result;
    } catch (e) {
      return this.handleError(e);
    }
  };

  handleResult = (result) => {
    let text = this.messageText;
    for (const key in result) {
      text += `${key} : ${result[key]}\n`;
    }
    this.props.showAndHide({ type: 'success', text });
    // this.props.history.push('/submissions/new')
    this.props.history.goBack();
  };

  handleError = (error) => {
    console.error(error);
    const text = error.error ? error.error : 'Unknown error';
    this.props.showAndHide({ type: 'An Error occurred', text });
  };

  getPromoSelectedhandleChange(e) {
    this.setState({ promo: e.target.value });
    Logger.log(`Selected value ${e.target.value}`);
  }

  approveSubmission = async (type = null) => {
    this.messageText = 'Submission Approved';
    let bonus = null;
    let override_value = null;

    this.setState({
      loadingAction: true,
    });

    if (type && CUSTOM_APPROVE_OPTIONS[type]) {
      const taskValue = this.state.data.value;
      const approveOption = CUSTOM_APPROVE_OPTIONS[type];
      const hasOverrideValue = approveOption.hasOwnProperty('override_value');

      // If we have an overridden value we don't send a bonus
      if (hasOverrideValue) {
        bonus = null;
        override_value = approveOption.override_value;
      }
      // If we have the approve option, we validate the task value and if we can get the bonus
      else if (approveOption.constraint(taskValue)) {
        bonus = approveOption.getBonus(taskValue);
        override_value = null;
      } else {
        alert(approveOption.errorAlert);
        return;
      }
    } else {
      const taskValue = this.state.data.value;
      const approveOption = CUSTOM_APPROVE_OPTIONS[this.state.promo];
      bonus = approveOption.getBonus(taskValue);
    }

    Logger.log(`bonus: ${bonus}`);
    Logger.log(`override_value: ${override_value}`);

    // Check if there are reviewed and approved tasks with the current taskId
    const { id, taskId } = this.state.data.submission;
    const { hasApproved } = this.checkApproved({ id, taskId });

    if (hasApproved) {
      return;
    }

    const payload = {
      approved: true,
      reviewed: true,
      bonus,
      override_value,
      version: this.state.data.version,
    };
    const result = await this.handleSubmit(payload);
    if (result) {
      this.handleResult({ ...result });
    }
  };

  checkApproved = async ({ id, taskId }) => {
    const submissions = await service.get(
      // `zombie/user-submissions/?task_id=610433384000eb000117d6ec`
      `zombie/user-submissions/?task_id=${taskId}`,
    );
    const approvedResults = submissions.results.filter(({ metaData }) => {
      const { reviewed, approved } = metaData;
      return reviewed === true && approved === true;
    });
    const usernames = approvedResults.map(({ user }) => user.username);
    const reviewers = formatList([...new Set(usernames)]);
    const approvedTotal = approvedResults.length;
    const hasApproved = approvedTotal > 0;

    if (hasApproved) {
      this.props.showAndHide(
        {
          type: 'error',
          text: `Se encontraron ${approvedTotal} tareas con taskId: ${taskId} aprobadas previamente por ${reviewers}.`,
        },
        10000,
      );
      this.setState({ loadingAction: false });
      Logger.table({
        message: `Error: Approved tasks found.`,
        id,
        taskId,
      });
    } else {
      Logger.table({
        message: `No previously approved tasks found.`,
        id,
        taskId,
      });
    }

    return { hasApproved };
  };

  skuPostObj = (taskId, metaData, sku) => ({
    task_id: taskId,
    meta_data: metaData,
    name_string: sku.nameString,
    sku: null,
    skus: [],
  });

  skuKeyValue = (key, value) => ({
    question_key: key,
    value,
  });

  Product = () => ({
    nameString: null,
    price: null,
    expiredCount: null,
    stockStatus: null,
    frontsCount: null,
    expiredPhoto: null,
    stockPhoto: null,
  });

  makeSkuPost = (skus) => {
    const postData = [];
    const metaDataId = this.state.data.id;
    const { taskId } = this.state.data.submission;
    skus.forEach((sku) => {
      const skuObj = new this.skuPostObj(taskId, metaDataId, sku);
      postData.push(skuObj);
    });
    return postData;
  };

  updateSkuData = async () => {
    try {
      const result = await this.postSkuData();
      this.handleResult(result);
    } catch (e) {
      this.handleError(e);
    }
  };

  postSkuData = async () => {
    try {
      const data = { skus: this.state.parsedQuestions.skuPostData };
      const result = await service.post('zombie/sku-add', data);
      this.messageText += ' - SKU Data saved.';
      return result;
    } catch (e) {
      this.messageText += ' - Error - SKU NOT Data saved.';
      return this.handleError(e);
    }
  };

  getRejectionText = (id) => {
    const optionsData = this.state.rejections;
    let returnVal = '';
    for (const i in optionsData) {
      if (optionsData[i].id === parseInt(id)) {
        returnVal = `${optionsData[i].reasonString} : `;
        break;
      }
    }
    return returnVal;
  };

  rejectSubmission = async (values) => {
    try {
      const { comments, rejectionCauses } = values;
      const rejectionText = rejectionCauses.map(this.getRejectionText);
      this.messageText = 'Submission Rejected';
      const payload = {
        approved: false,
        reviewed: true,
        comments,
        rejectionCauses,
        version: this.state.data.version,
      };
      const result = await this.handleSubmit(payload);
      this.toggleRejectForm();
      this.handleResult(result);
    } catch (e) {
      this.handleError(e);
    }
  };

  handleSoftRejectSubmit = async (values) => {
    this.messageText = 'Submission Soft Rejected';
    try {
      const result = await this.handleSRSubmit({
        reviewed: true,
        comments: values.comments,
        rejectionCauses: values.rejectionCauses,
        version: this.state.data.version,
      });
      this.toggleSoftRejectForm();

      if (result) {
        this.handleResult({ ...result });
      }
    } catch (e) {
      this.handleError(e);
    }
  };

  renderQuestions = (data) => {
    if (!data) return;
    const questions = [];
    _.forIn(data, (val, key) => {
      if (_.startsWith(val, 'http')) {
        this.images.push({ key: val });
      } else {
        questions.push(<QuestionRow key={questions.length} q={key} a={val} />);
      }
    });
    return <Table rows={questions} />;
  };

  renderSkus = (skus, brandId) => {
    if (_.isEmpty(skus)) return;
    const tableRows = [];
    tableRows.push(<SkuHeader key={1000} sku={skus[0]} />);
    skus.forEach((sku, index) => {
      tableRows.push(
        <SKURow
          key={index}
          sku={sku}
          folio={this.state.filterNumber}
          lookerID={this.state.brandConfig.nameString}
          brandId={brandId}
        />,
      );
    });

    return <Table rows={tableRows} />;
  };

  renderLastSoftReject = (lastSoftReject) => {
    const { comments, rejectionCauses } = lastSoftReject;

    return (
      <div className='soft-reject-container'>
        <br />
        <div>
          <strong>Soft Rejections Causes</strong>
        </div>
        <hr />
        <div>
          <strong>Comments:</strong>
          {comments}
        </div>
        <div>
          <strong>Causes:</strong>
        </div>
        <div className='rejection-causes'>
          {rejectionCauses.map((obj, id) => (
            <div key={id}>{`- ${obj.reasonString}`}</div>
          ))}
        </div>
      </div>
    );
  };

  setImage = (obj) => {
    this.setState({ currentImage: obj });
  };

  getTruthy = (val) => (val ? 'true' : 'false');

  toggleMap() {
    this.setState((prevState) => ({
      mapModal: !prevState.mapModal,
    }));
  }

  toggleRejectForm() {
    this.setState((prevState) => ({
      rejectFormModal: !prevState.rejectFormModal,
    }));
  }

  toggleSoftRejectForm() {
    this.setState((prevState) => ({
      softRejectFormModal: !prevState.softRejectFormModal,
    }));
  }

  toggleInfo = () => {
    this.setState((prevState) => ({
      imageInfo: !prevState.imageInfo,
    }));
  };

  storeString = (store) => {
    if (store) {
      const storeString = store
        ? store.name !== ''
          ? store.name
          : store.city
        : 'n/a';
      return `[${store.zubaleId}] ${store.retailer.name} - ${storeString}`;
    }
    return 'n/a';
  };

  cityString = (store) => {
    if (store) {
      return store.city ? store.city : 'n/a';
    }
    return 'n/a';
  };

  retailerString = (store) => {
    if (store) {
      return `[${store.retailer.zubaleId}] ${store.retailer.name}`;
    }
    return 'n/a';
  };

  onKeyDown(keyName, e, handle) {
    if (
      keyName === 'A' &&
      !(this.state.loadingAction || this.state.data.approved)
    ) {
      return this.approveSubmission();
    }
    if (
      keyName === 'R' &&
      !(this.state.loadingAction || this.state.data.approved !== null)
    ) {
      return this.toggleRejectForm();
    }
    if (
      keyName === 'S' &&
      !(this.state.loadingAction || !this.state.data.approved)
    ) {
      return this.updateSkuData();
    }
    // Todo: add reject validation
    if (
      keyName === 'T' &&
      !(this.state.loadingAction || this.state.data.approved !== null)
    ) {
      return this.toggleSoftRejectForm();
    }
  }

  showSRButton(data) {
    return (
      data.submission.additionalData === null ||
      (data.submission.additionalData !== null &&
        !data.submission.additionalData.allowSoftReject) ||
      this.state.loadingAction ||
      data.approved !== null ||
      data.brand == null ||
      (data.brand !== null && !data.brand.allowSoftReject)
    );
  }

  render() {
    const {
      auth,
      parsedQuestions,
      data,
      loading,
      loadingAction,
      error,
      filterNumber,
      brandId,
      brandConfig,
    } = this.state;
    if (error) return <span />;

    const dashboardParams = {
      phoneNumber: _.get(data, 'submission.phoneNumber', ''),
      submissionDate: _.get(data, 'submission.createdOn', ''),
      brandId: _.get(data, 'brand.id', -1),
      storeId: _.get(data, 'store.id', -1),
      userId: _.get(data, 'submission.userUuid', ''),
      responses: filterNumber || '',
      orderId: filterNumber || '',
    };

    const showLiveTrackingUrl = getShowLiveTrackingUrl(data);
    const mapInfo = !_.get(this.state, 'currentImage.latitude', false) ? (
      <span className='missingInfo'>
        Imágen actual Sin información de ubicación
      </span>
    ) : (
      <a
        href={`${googleMapsUrl(
          _.get(data, 'store.point'),
          _.get(this.state, 'currentImage'),
        )}`}
        className='bigButton btn btn-sm googleMapsBtn'
        target='_new'>
        <FaMapPin />
        &nbsp;Comparar ubicación en Google Maps
      </a>
    );

    return (
      <Hotkeys keyName='A, R, S, T' onKeyDown={this.onKeyDown.bind(this)}>
        <div className='submissionView'>
          {loading || !data || filterNumber == null || brandId === null ? (
            <div className='loading-spinner-container'>
              <Spinner animation='grow' role='status'>
                <span>Loading...</span>
              </Spinner>
            </div>
          ) : (
            <div>
              <div className='infoDiv'>
                <Row>
                  <Col>
                    <Row>
                      <Col>
                        Date:
                        {formatDate(data.submission.createdOn)}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        TaskID:
                        {data.submission.taskId}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Value:
                        {data.value ? data.value : 'n/a'}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        User Phone:
                        {data.submission.phoneNumber}
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row>
                      <Col>
                        UUID:
                        {data.userUuid ? data.userUuid : 'n/a'}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Brand:
                        {data.brand ? data.brand.name : 'n/a'}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Retailer:
                        {this.retailerString(data.store)}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        City:
                        {this.cityString(data.store)}
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row>
                      <Col>
                        Reviewer:{' '}
                        {data.submissionReview
                          ? data.submissionReview.user.username
                          : 'n/a'}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Submission Result: {data.submissionResult}{' '}
                        {data.submission.additionalData != null ? (
                          <span className='badge badge-info'>
                            Num SoftReject ({' '}
                            {data.submission.additionalData.countSoftReject} )
                          </span>
                        ) : (
                          ''
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Store:
                        {this.storeString(data.store)}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Store Number:{' '}
                        <div id='storeNumber'>
                          {_.get(data, 'store.storeNumber', '---')}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className='task-response-header-container'>
                <h4 className='task-response-header'>Task Responses</h4>
                {auth.user.profile.isAdmin && (
                  <div className='approve-button-container'>
                    <label htmlFor='promoChoice'>Valor de tarea:</label>
                    <select
                      id='promoChoice'
                      value={this.state.promo}
                      onChange={this.getPromoSelectedhandleChange}>
                      {dropDown.map((option, i) => (
                        <option key={i} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <Button
                      disabled
                      className='bigButton'
                      size='sm'
                      color='warning'>
                      In Review
                    </Button>
                    <Button
                      disabled={loadingAction || data.approved}
                      className='bigButton'
                      size='sm'
                      color='success'
                      onClick={this.approveSubmission}>
                      Approve (A)
                    </Button>
                    {!this.showSRButton(data) && (
                      <Button
                        className='bigButton'
                        size='sm'
                        color='info'
                        onClick={this.toggleSoftRejectForm}>
                        Soft Reject (T)
                      </Button>
                    )}
                    <Button
                      disabled={loadingAction || data.approved !== null}
                      className='bigButton'
                      size='sm'
                      color='danger'
                      onClick={this.toggleRejectForm}>
                      Reject (R)
                    </Button>
                    <Button
                      disabled={loadingAction || !data.approved}
                      className='bigButton'
                      size='sm'
                      color='danger'
                      onClick={this.updateSkuData}>
                      Save SKU Data (S)
                    </Button>
                    {Object.values(EXTRA_APPROVE_BTNS).map((opt) => {
                      const [key, value] = opt;
                      return (
                        <Button
                          key={key}
                          disabled={loadingAction || data.approved}
                          className='bigButton'
                          size='sm'
                          color='success'
                          onClick={() => this.approveSubmission(key)}>
                          {value.label}
                        </Button>
                      );
                    })}
                  </div>
                )}
              </div>

              <Row>
                <Row className='map-info-container'>
                  <Row className='map-info-container details-container'>
                    {this.state.currentImage && (
                      <p>{`[${this.state.currentImage.id}] - ${this.state.currentImage.questionText}`}</p>
                    )}
                  </Row>
                  <Col xs='8' className='details-container'>
                    <ImagesComponent
                      currentImage={this.state.currentImage}
                      toggleInfo={this.toggleInfo}
                      images={data.images}
                      toggleMap={this.toggleMap}
                      infoState={this.state.imageInfo}
                      imageSetter={this.setImage}
                    />
                  </Col>
                  <Col xs='4' className='details-container'>
                    <Row>
                      <Col>
                        <div className='submission-header'>{mapInfo}</div>
                      </Col>
                    </Row>
                    <ImageInfo image={this.state.currentImage} />
                  </Col>
                </Row>
                {showLiveTrackingUrl ? (
                  <Row>
                    <Col>
                      <div className='submission-header'>
                        <a
                          href={`${liveTrackingUrl}?token=${data.submission.taskId}`}
                          target='_new'>
                          <FaMapMarkerAlt />
                          Live Tracking
                        </a>
                      </div>
                    </Col>
                  </Row>
                ) : null}
                <Row>
                  <Col>
                    <div className='submission-header'>
                      <div className='submission-boxes'>
                        {brandConfig.ApprovedTasksCO && (
                          <ApprovedTasksDashboardCO
                            brandId={brandId}
                            phone={dashboardParams.phoneNumber}
                            dateCreated={dashboardParams.submissionDate}
                          />
                        )}
                        {brandConfig.ApprovedTasksMX && (
                          <ApprovedTasksDashboardMX
                            brandId={brandId}
                            phone={dashboardParams.phoneNumber}
                            dateCreated={dashboardParams.submissionDate}
                          />
                        )}
                        {brandConfig.ApprovedTasksBR25 && (
                          <ApprovedTasksDashboardBR25
                            brandId={brandId}
                            phone={dashboardParams.phoneNumber}
                            dateCreated={dashboardParams.submissionDate}
                          />
                        )}
                        {brandConfig.ApprovedTasksBR30 && (
                          <ApprovedTasksDashboardBR30
                            brandId={brandId}
                            phone={dashboardParams.phoneNumber}
                            dateCreated={dashboardParams.submissionDate}
                          />
                        )}
                        {brandConfig.ApprovedTasksBR35 && (
                          <ApprovedTasksDashboardBR35
                            brandId={brandId}
                            phone={dashboardParams.phoneNumber}
                            dateCreated={dashboardParams.submissionDate}
                          />
                        )}
                        {brandConfig.ApprovedTasksBR40 && (
                          <ApprovedTasksDashboardBR40
                            brandId={brandId}
                            phone={dashboardParams.phoneNumber}
                            dateCreated={dashboardParams.submissionDate}
                          />
                        )}
                        {brandConfig.KeywordCrossCheck && (
                          <KeywordCrossCheckDashboard
                            brandId={brandId}
                            isNumeric={brandConfig.KeywordCrossCheck.isNumeric}
                            keyword={brandConfig.KeywordCrossCheck.keyword}
                            nameString={
                              brandConfig.KeywordCrossCheck.nameString
                            }
                            responses={dashboardParams.responses}
                            dateCreated={dashboardParams.submissionDate}
                          />
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Row className='map-info-container details-container'>
                      {data.lastSoftReject
                        ? this.renderLastSoftReject(data.lastSoftReject)
                        : null}
                    </Row>
                    <div className='responses'>
                      {this.renderSkus(
                        parsedQuestions.skus,
                        _.get(data, 'brand.id'),
                      )}
                      {this.renderQuestions(parsedQuestions.other)}
                    </div>

                    <div>
                      <a
                        href={data.submission.formUrl}
                        target='_blank'
                        rel='noopener noreferrer'>
                        {data.submission.formUrl}
                      </a>
                    </div>
                    <div className='rejection-causes'>
                      {data.rejectionCauses.map((obj, id) => (
                        <div key={id}>{`- ${obj.reasonString}`}</div>
                      ))}
                    </div>
                  </Col>
                </Row>

                <RejectionModal
                  data={this.state.rejections}
                  handleSubmit={this.rejectSubmission}
                  toggle={this.toggleRejectForm}
                  isOpen={this.state.rejectFormModal}
                />
                <SoftRejectionModal
                  data={this.state.rejections}
                  handleSubmit={this.handleSoftRejectSubmit}
                  toggle={this.toggleSoftRejectForm}
                  isOpen={this.state.softRejectFormModal}
                />
              </Row>
            </div>
          )}
        </div>
      </Hotkeys>
    );
  }
}

const mapStateToProps = ({ message, auth }) => ({
  message,
  auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ showMessage, showAndHide }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Submission);
